import React from "react";
import "./StudentMentalHealth.css";
import Header from "./Header";
import Footer from "./Footer";
import topback from "../images/beetitle.png";

const SOP = () => {
  return (
    <>
      <Header />

      <section class="content-section title-top" style={{ backgroundImage: `url(${topback})` }}>
        <div class="pattern-overlay">
          <div class="container">
            <div class="row">
              <div className="col-lg-12 title-heading text-center mb-4">

                <h2 className="page-title" style={{ marginBottom: '3rem' }}>
                  SANT DHANGU WALE GUJJAR GOVERNMENT COLLEGE
                </h2>

                <h5 className="mt-3" style={{ color: '#fff' }}>
                  Beetan (District Una, Himachal Pradesh)
                </h5>

              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container mt-4 mb-5">


        <div className="text-center mb-4">

        
          <h3 className="mt-3">
            STANDARD OPERATING PROCEDURE (SOP)
          </h3>

          <h5 className="text-primary">
            Mental Health Crisis Management
          </h5>

        </div>

        <table className="table table-bordered">

          <tbody>

            <tr>
              <th width="25%">Effective From</th>
              <td>2026-27</td>
            </tr>

            <tr>
              <th>Approved By</th>
              <td>Principal</td>
            </tr>

            <tr>
              <th>Review Period</th>
              <td>Annually</td>
            </tr>

          </tbody>

        </table>

        {/* ========================= */}

        {/* 1. PURPOSE */}

        {/* ========================= */}

        <section>

          <h3>1. Purpose</h3>

          <p>
            This Standard Operating Procedure (SOP) establishes a clear
            protocol for identifying, responding to, managing and following
            up on mental health crises involving students and staff of
            SDWG Government College, Beetan, ensuring safety, dignity,
            confidentiality and timely professional support.
          </p>

        </section>

        {/* ========================= */}

        {/* 2. OBJECTIVES */}

        {/* ========================= */}

        <section>

          <h3>2. Objectives</h3>

          <ul>

            <li>Protect life and ensure immediate safety.</li>

            <li>Provide prompt psychological support.</li>

            <li>Coordinate with healthcare professionals.</li>

            <li>
              Inform parents/guardians whenever appropriate.
            </li>

            <li>
              Facilitate safe reintegration into academics.
            </li>

            <li>
              Promote a supportive campus environment.
            </li>

          </ul>

        </section>

        {/* ========================= */}

        {/* 3. SCOPE */}

        {/* ========================= */}

        <section>

          <h3>3. Scope</h3>

          <p>Applicable to:</p>

          <ul>

            <li>All Students</li>

            <li>Faculty Members</li>

            <li>Non-Teaching Staff</li>

            <li>Student Wellness Centre</li>

            <li>NCC / NSS Volunteers</li>

            <li>Student Mentors</li>

          </ul>

        </section>

        {/* ========================= */}

        {/* 4. DEFINITION */}

        {/* ========================= */}

        <section>

          <h3>4. Definition of Mental Health Crisis</h3>

          <p>A crisis may include:</p>

          <ul>

            <li>Suicidal thoughts or attempts.</li>

            <li>Self-harm behaviour.</li>

            <li>Panic attack.</li>

            <li>Severe anxiety.</li>

            <li>Emotional breakdown.</li>

            <li>Aggressive or violent behaviour.</li>

            <li>Psychotic symptoms.</li>

            <li>Extreme depression.</li>

            <li>
              Any behaviour posing immediate risk to self or others.
            </li>

          </ul>

        </section>

        {/* ========================= */}

        {/* 5. MHCRT */}

        {/* ========================= */}

        <section>

          <h3>5. Mental Health Crisis Response Team (MHCRT)</h3>

          <table className="table table-bordered table-striped">

            <thead>

              <tr>

                <th width="30%">Role</th>

                <th>Designation</th>

              </tr>

            </thead>

            <tbody>

              <tr>

                <td>Chairperson</td>

                <td>Principal</td>

              </tr>

              <tr>

                <td>Coordinator</td>

                <td>Student Wellness Centre Coordinator</td>

              </tr>

              <tr>

                <td>Members</td>

                <td>

                  <ul className="mb-0">

                    <li>Faculty Counsellor</li>

                    <li>Anti-Ragging Committee</li>

                    <li>Women Cell NSS Programme Officer</li>

                    <li>NCC Officer</li>

                    <li>Office Superintendent</li>

                  </ul>

                </td>

              </tr>

            </tbody>

          </table>

        </section>

        <section>

          <h3>6. Warning Signs</h3>

          <p>
            Faculty members and students should immediately report if someone:
          </p>

          <ul>
            <li>Talks about suicide.</li>
            <li>Writes farewell messages.</li>
            <li>Gives away belongings.</li>
            <li>Suddenly withdraws socially.</li>
            <li>Cries uncontrollably.</li>
            <li>Displays extreme anger.</li>
            <li>Refuses food for several days.</li>
            <li>Appears disoriented or hallucinating.</li>
            <li>Expresses hopelessness.</li>
            <li>Shows sudden behavioural changes.</li>
          </ul>

        </section>

        {/* ========================= */}
        {/* 7. CRISIS RESPONSE PROCEDURE */}
        {/* ========================= */}

        <section>

          <h3>7. Crisis Response Procedure</h3>

          <h5 className="mt-4">Step 1 : Ensure Immediate Safety</h5>

          <ul>
            <li>Stay with the student.</li>
            <li>Never leave the student alone.</li>
            <li>Remove harmful objects if safely possible.</li>
            <li>Shift the student to a quiet room.</li>
          </ul>

          <h5 className="mt-4">Step 2 : Inform Authorities</h5>

          <p>Immediately inform:</p>

          <ul>
            <li>Principal</li>
            <li>Student Wellness Centre Coordinator</li>
            <li>Concerned Faculty Mentor</li>
          </ul>

          <h5 className="mt-4">Step 3 : Assess Urgency</h5>

          <table className="table table-bordered">

            <thead className="table-light">
              <tr>
                <th width="25%">Risk Level</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>

              <tr>
                <td><strong>Low Risk</strong></td>
                <td>
                  <ul className="mb-0">
                    <li>Student distressed but cooperative.</li>
                    <li>Arrange counselling within 24 hours.</li>
                  </ul>
                </td>
              </tr>

              <tr>
                <td><strong>Moderate Risk</strong></td>
                <td>
                  <ul className="mb-0">
                    <li>Suicidal thoughts without immediate plan.</li>
                    <li>Inform parents.</li>
                    <li>Refer to Psychiatrist / Clinical Psychologist.</li>
                  </ul>
                </td>
              </tr>

              <tr>
                <td><strong>High Risk</strong></td>
                <td>
                  <ul className="mb-0">
                    <li>Suicide attempt.</li>
                    <li>Active self-harm.</li>
                    <li>Violent behaviour.</li>
                    <li>Loss of consciousness.</li>
                  </ul>

                  <strong>Immediately:</strong>

                  <ul className="mb-0 mt-2">
                    <li>Call 108 Emergency Ambulance.</li>
                    <li>Shift to the nearest Government Hospital.</li>
                    <li>Inform parents/guardian without delay.</li>
                  </ul>

                </td>
              </tr>

            </tbody>

          </table>

        </section>

        {/* ========================= */}
        {/* 8. COMMUNICATION GUIDELINES */}
        {/* ========================= */}

        <section>

          <h3>8. Communication Guidelines</h3>

          <div className="row">

            <div className="col-md-6">

              <h5>Faculty Should</h5>

              <ul>
                <li>Remain calm.</li>
                <li>Listen without judgement.</li>
                <li>Speak softly.</li>
                <li>Reassure the student.</li>
              </ul>

            </div>

            <div className="col-md-6">

              <h5>Do NOT</h5>

              <ul>
                <li>Scold.</li>
                <li>Blame.</li>
                <li>Threaten.</li>
                <li>Share information publicly.</li>
                <li>Crowd around the student.</li>
              </ul>

            </div>

          </div>

        </section>

        {/* ========================= */}
        {/* 9. PARENT / GUARDIAN NOTIFICATION */}
        {/* ========================= */}

        <section>

          <h3>9. Parent / Guardian Notification</h3>

          <p>
            Parents shall be informed immediately in the following situations:
          </p>

          <ul>
            <li>Suicide attempt.</li>
            <li>Self-harm.</li>
            <li>Hospital referral.</li>
            <li>Severe psychiatric symptoms.</li>
            <li>Any situation involving immediate safety.</li>
          </ul>

        </section>

        {/* ========================= */}
        {/* 10. REFERRAL SERVICES */}
        {/* ========================= */}

        <section>

          <h3>10. Referral Services</h3>

          <p>Students may be referred to:</p>

          <ul>
            <li>District Mental Health Programme (DMHP), Una.</li>
            <li>Clinical Psychologist.</li>
            <li>Psychiatrist.</li>
            <li>Tele-MANAS.</li>
          </ul>

          <table className="table table-bordered">

            <tbody>

              <tr>

                <th width="35%">
                  National Mental Health Helpline
                </th>

                <td>
                  <strong>Tele-MANAS</strong><br />
                  14416 or 1800-891-4416 (24×7)
                </td>

              </tr>

            </tbody>

          </table>

        </section>

        <section>

          <h3>11. Documentation</h3>

          <p>The Coordinator shall maintain confidential records including:</p>

          <ul>
            <li>Date</li>
            <li>Time</li>
            <li>Student Details</li>
            <li>Nature of Crisis</li>
            <li>Persons Present</li>
            <li>Action Taken</li>
            <li>Referral Details</li>
            <li>Parent Informed (Yes / No)</li>
            <li>Follow-up Schedule</li>
          </ul>

          <p>
            <strong>Note:</strong> All records shall remain strictly confidential.
          </p>

        </section>

        {/* ========================= */}
        {/* 12. FOLLOW-UP */}
        {/* ========================= */}

        <section>

          <h3>12. Follow-Up</h3>

          <table className="table table-bordered">

            <thead className="table-light">

              <tr>
                <th width="30%">Time</th>
                <th>Action</th>
              </tr>

            </thead>

            <tbody>

              <tr>
                <td>Within 48 Hours</td>
                <td>Wellness Coordinator contacts the student.</td>
              </tr>

              <tr>
                <td>One Week</td>
                <td>Counselling Review.</td>
              </tr>

              <tr>
                <td>One Month</td>
                <td>Academic Adjustment Review.</td>
              </tr>

              <tr>
                <td>Three Months</td>
                <td>Reintegration Assessment.</td>
              </tr>

            </tbody>

          </table>

        </section>

        {/* ========================= */}
        {/* 13. CONFIDENTIALITY */}
        {/* ========================= */}

        <section>

          <h3>13. Confidentiality</h3>

          <p>
            Information shall only be shared with:
          </p>

          <ul>
            <li>Principal</li>
            <li>Wellness Coordinator</li>
            <li>Treating Mental Health Professional</li>
            <li>Parent / Guardian (when necessary)</li>
            <li>Emergency Medical Personnel</li>
          </ul>

          <p>
            Privacy shall be maintained except where disclosure is necessary
            to prevent serious harm.
          </p>

        </section>

        {/* ========================= */}
        {/* 14. PREVENTION MEASURES */}
        {/* ========================= */}

        <section>

          <h3>14. Prevention Measures</h3>

          <p>The College shall organise:</p>

          <ul>

            <li>Mental Health Awareness Week</li>

            <li>Stress Management Workshops</li>

            <li>Yoga & Meditation Sessions</li>

            <li>Peer Support Groups</li>

            <li>Faculty Sensitisation Programmes</li>

            <li>Orientation on Emotional Wellbeing</li>

            <li>Anti-Bullying and Anti-Ragging Awareness</li>

            <li>Life Skills Training</li>

          </ul>

        </section>

        {/* ========================= */}
        {/* 15. FLOW CHART */}
        {/* ========================= */}

        <section>

          <h3>15. Mental Health Crisis Response Flow Chart</h3>

          <div className="flow-chart">

            <div className="flow-box">Student in Distress</div>

            <div className="arrow">↓</div>

            <div className="flow-box">
              Identify Warning Signs
            </div>

            <div className="arrow">↓</div>

            <div className="flow-box">
              Ensure Immediate Safety
              <br />
              (Stay with the student and remove immediate risks)
            </div>

            <div className="arrow">↓</div>

            <div className="flow-box">
              Inform Principal & Student Wellness Centre Coordinator
            </div>

            <div className="arrow">↓</div>

            <div className="flow-box">
              Assess Risk Level
            </div>

            <div className="arrow">↓</div>

            <div className="row mt-4">

              <div className="col-md-6 text-center">

                <div className="flow-box bg-light">

                  <strong>No (Low / Moderate Risk)</strong>

                  <hr />

                  Provide Counselling

                  <br />

                  Refer to Mental Health Professional

                </div>

              </div>

              <div className="col-md-6 text-center">

                <div className="flow-box bg-light">

                  <strong>Yes (High Risk)</strong>

                  <hr />

                  Call 108 Ambulance

                  <br />

                  Shift to Hospital

                  <br />

                  Inform Parent / Guardian

                </div>

              </div>

            </div>

            <div className="arrow mt-3">↓</div>

            <div className="flow-box">
              Document the Incident and Actions Taken
            </div>

            <div className="arrow">↓</div>

            <div className="flow-box">
              Follow-up Counselling & Academic Reintegration
            </div>

            <div className="arrow">↓</div>

            <div className="flow-box">
              Periodic Review and Student Well-being Monitoring
            </div>

          </div>

        </section>

        {/* ========================= */}
        {/* 16. SOP FOR POSTVENTION */}
        {/* ========================= */}

        <section>

          <h3>16. SOP for Postvention (Step-wise)</h3>

          <table className="table table-bordered table-striped">

            <thead>

              <tr>

                <th width="18%">Step</th>

                <th>Action</th>

              </tr>

            </thead>

            <tbody>

              <tr>

                <td>Step 1</td>

                <td>
                 Activate the Crisis Response Team: The Principal shall immediately activate the Student Wellness Centre/Crisis Response Team following a mental health crisis, suicide attempt, or death by suicide.
                </td>

              </tr>

              <tr>

                <td>Step 2</td>

                <td>
                  Provide psychological first aid and emotional support
                  to affected students and staff.
                </td>

              </tr>

              <tr>

                <td>Step 3</td>

                <td>
                  Inform Parents / Guardians and maintain communication.
                </td>

              </tr>

              <tr>

                <td>Step 4</td>

                <td>
                  Ensure sensitive communication while maintaining
                  confidentiality and avoiding rumours.
                </td>

              </tr>

              <tr>

                <td>Step 5</td>

                <td>
                  Arrange professional counselling through qualified
                  mental health professionals or DMHP.
                </td>

              </tr>

              <tr>

                <td>Step 6</td>

                <td>
                  Identify and support vulnerable students by providing
                  counselling and academic assistance.
                </td>

              </tr>

              <tr>

                <td>Step 7</td>

                <td>
                  Document the incident, actions taken, referrals and
                  follow-up interventions.
                </td>

              </tr>

              <tr>

                <td>Step 8</td>

                <td>
                  Review and improve the institutional response to
                  strengthen future crisis prevention.
                </td>

              </tr>

            </tbody>

          </table>

        </section>

      </div>
      <Footer />
    </>
  );
}
export default SOP